import React, { InputHTMLAttributes, RefAttributes, useEffect, useRef, useState } from 'react'
import { classNames } from '../wrapper'

function toString (value: number, fractionDigits?: number): string {
    if (fractionDigits === undefined) { return value.toString() }

    return value.toFixed(fractionDigits)
}

const Number: React.FC<{
    value: number;
    change: (number: number) => void;
    children?: (attrs: InputHTMLAttributes<any> & RefAttributes<any>) => React.ReactNode
    fractionDigits?: number;
    error?: boolean;
}> = (props) => {
    const [last, setLast] = useState('')
    const inputRef = useRef<HTMLInputElement>(null)

    useEffect(() => {
        if (inputRef.current !== document.activeElement) {
            setLast(toString(props.value, props.fractionDigits))
        }
    }, [props.value, props.fractionDigits])

    function onChange (input: string) {
        setLast(input)
        const v = parseFloat(input.replace(',', '.'))
        if (!isNaN(v) && isFinite(v)) {
            props.change(v)
        }
    }

    function onBlur () {
        // revert to last valid value
        setLast(toString(props.value, props.fractionDigits))
    }

    if (props.children) {
        return <>
            {props.children({
                value: last,
                onBlur: () => onBlur(),
                onInput: (e) => onChange((e.target as HTMLInputElement).value),
                ref: inputRef
            })}
        </>
    }

    return <input ref={inputRef} inputMode='decimal' className={classNames('input border', props.error ? 'border-error-300' : 'border-gray-300')} value={last} onBlur={() => onBlur()} onInput={(e) => onChange((e.target as HTMLInputElement).value)} onWheel={(e) => e.currentTarget.blur()} />
}

export default Number
